import styles from "./WaveLayout.module.scss";

export function WaveLayout({ children }) {
  return (
    <div className={styles.background}>
      <div className={styles.aligner}>{children}</div>
    </div>
  );
}
